import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import Field from "../../../../../components/Field";
import { useOrgSettingsResourceLabel } from "../../../../../utils/hooks/useOrgSettingsResourceLabel";
import {
	getSettingsOrgResourceSearchFilters,
	renderSettingsResourceLabel,
} from "../../../../../utils/helpers/settings";
import { firstToUpper } from "../../../../../utils/helpers/string";

function Group({ name, group }) {
	const { t } = useTranslation();
	const renderOrgLevelResourceLabel = useOrgSettingsResourceLabel();

	return (
		<Field
			name={name}
			label={firstToUpper(group.description)}
			rules={[
				{
					required: group.isRequired,
					message: group.isRequired
						? t("required-group", { group: renderSettingsResourceLabel(group) })
						: "",
				},
			]}
		>
			<ResourceSelect
				labelPropName="description"
				resourcePath={`/${group.id}/org-levels`}
				placeholder={t("select-group", {
					group: renderSettingsResourceLabel(group),
				})}
				renderLabel={renderOrgLevelResourceLabel}
				allowClear={!group.isRequired}
				hasSearch
				getSearchFilters={getSettingsOrgResourceSearchFilters}
			/>
		</Field>
	);
}

export default Group;
